export default __webpack_public_path__ + "static/collectiveposter-51633b6be865c0afea02adecbb94447f.jpg";